import React from "react"
import HalfStyled from "../styles/half/halfStyles"
import uuid from "react-uuid"
import TitleStyled from "../styles/titleStyles"

const halfLongDescription = ({ heading, row, position }) => {
  return (
    <HalfStyled className="halfLongDescription">
      <div className="half__wrapper">
        <div
          className={`half__content ${
            position === "left" ? "half__content--left" : "half__content--right"
          }`}
        >
          <TitleStyled
            textAlign="left"
            linePosition="left"
            color="#000"
            lineColor="#000"
          >
            <h2 dangerouslySetInnerHTML={{ __html: heading }}></h2>
          </TitleStyled>
          <div className="half__wrapper__row">
            {row.map(item => {
              return (
                <div key={uuid()} className="half__wrapper__row__item">
                  <p
                    className="half__wrapper__row__title"
                    style={{ color: item.value.headingColor }}
                    dangerouslySetInnerHTML={{ __html: item.value.heading }}
                  ></p>
                  <div
                    className="half__wrapper__row__description"
                    dangerouslySetInnerHTML={{ __html: item.value.description }}
                  ></div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </HalfStyled>
  )
}

export default halfLongDescription
